import router from "@/router/index";
import * as model from "@/model/prd/qualityMgt/pelletizing/SlagMeltingPoint";
import {
    newEntityStoreHelper
} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SlagMeltingPoint(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
        qualityPlanStatus: '',
    }) //TODO load at the application start
    .buildStore()